export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrowDown"] = 2] = "ArrowDown";
    IconSymbol[IconSymbol["ArrowLeft"] = 3] = "ArrowLeft";
    IconSymbol[IconSymbol["ArrowRight"] = 4] = "ArrowRight";
    IconSymbol[IconSymbol["ArrowUp"] = 5] = "ArrowUp";
    IconSymbol[IconSymbol["AudioBus"] = 6] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 7] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 8] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 9] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 10] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 11] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 12] = "Book";
    IconSymbol[IconSymbol["Box"] = 13] = "Box";
    IconSymbol[IconSymbol["Browse"] = 14] = "Browse";
    IconSymbol[IconSymbol["Bug"] = 15] = "Bug";
    IconSymbol[IconSymbol["Capture"] = 16] = "Capture";
    IconSymbol[IconSymbol["Chain"] = 17] = "Chain";
    IconSymbol[IconSymbol["ChatEmpty"] = 18] = "ChatEmpty";
    IconSymbol[IconSymbol["ChatMessage"] = 19] = "ChatMessage";
    IconSymbol[IconSymbol["Copy"] = 20] = "Copy";
    IconSymbol[IconSymbol["Maximizer"] = 21] = "Maximizer";
    IconSymbol[IconSymbol["Fold"] = 22] = "Fold";
    IconSymbol[IconSymbol["Folder"] = 23] = "Folder";
    IconSymbol[IconSymbol["Charts"] = 24] = "Charts";
    IconSymbol[IconSymbol["Checkbox"] = 25] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 26] = "Clips";
    IconSymbol[IconSymbol["Close"] = 27] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 28] = "CloudFolder";
    IconSymbol[IconSymbol["Code"] = 29] = "Code";
    IconSymbol[IconSymbol["CollapseDown"] = 30] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 31] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 32] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 33] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 34] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 35] = "Curve";
    IconSymbol[IconSymbol["Dattorro"] = 36] = "Dattorro";
    IconSymbol[IconSymbol["Delete"] = 37] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 38] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 39] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 40] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 41] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 42] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 43] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 44] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 45] = "DrumSet";
    IconSymbol[IconSymbol["Tidal"] = 46] = "Tidal";
    IconSymbol[IconSymbol["Duration"] = 47] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 48] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 49] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 50] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 51] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 52] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 53] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 54] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 55] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 56] = "FileList";
    IconSymbol[IconSymbol["Film"] = 57] = "Film";
    IconSymbol[IconSymbol["Flask"] = 58] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 59] = "Focus";
    IconSymbol[IconSymbol["Fullscreen"] = 60] = "Fullscreen";
    IconSymbol[IconSymbol["Gate"] = 61] = "Gate";
    IconSymbol[IconSymbol["Generator"] = 62] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 63] = "GoogleDrive";
    IconSymbol[IconSymbol["Nextcloud"] = 64] = "Nextcloud";
    IconSymbol[IconSymbol["Groove"] = 65] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 66] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 67] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 68] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 69] = "Heart";
    IconSymbol[IconSymbol["Help"] = 70] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 71] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 72] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 73] = "Insert";
    IconSymbol[IconSymbol["InsertDown"] = 74] = "InsertDown";
    IconSymbol[IconSymbol["Invert"] = 75] = "Invert";
    IconSymbol[IconSymbol["Info"] = 76] = "Info";
    IconSymbol[IconSymbol["Lock"] = 77] = "Lock";
    IconSymbol[IconSymbol["Loop"] = 78] = "Loop";
    IconSymbol[IconSymbol["LoopEnd"] = 79] = "LoopEnd";
    IconSymbol[IconSymbol["LoopStart"] = 80] = "LoopStart";
    IconSymbol[IconSymbol["LowPass"] = 81] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 82] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 83] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 84] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 85] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 86] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 87] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 88] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 89] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 90] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 91] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 92] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 93] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 94] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 95] = "NanoWave";
    IconSymbol[IconSymbol["NeuralAmp"] = 96] = "NeuralAmp";
    IconSymbol[IconSymbol["New"] = 97] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 98] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 99] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 100] = "NotePad";
    IconSymbol[IconSymbol["OpenDAW"] = 101] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 102] = "Panel";
    IconSymbol[IconSymbol["Paste"] = 103] = "Paste";
    IconSymbol[IconSymbol["Peak"] = 104] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 105] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 106] = "Piano";
    IconSymbol[IconSymbol["Play"] = 107] = "Play";
    IconSymbol[IconSymbol["Playfield"] = 108] = "Playfield";
    IconSymbol[IconSymbol["PlayOnce"] = 109] = "PlayOnce";
    IconSymbol[IconSymbol["PlayRepeat"] = 110] = "PlayRepeat";
    IconSymbol[IconSymbol["PlayAlternate"] = 111] = "PlayAlternate";
    IconSymbol[IconSymbol["Pointer"] = 112] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 113] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 114] = "Primary";
    IconSymbol[IconSymbol["Random"] = 115] = "Random";
    IconSymbol[IconSymbol["Record"] = 116] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 117] = "Rectangle";
    IconSymbol[IconSymbol["Redo"] = 118] = "Redo";
    IconSymbol[IconSymbol["Region"] = 119] = "Region";
    IconSymbol[IconSymbol["Robot"] = 120] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 121] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 122] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 123] = "Run";
    IconSymbol[IconSymbol["Sawtooth"] = 124] = "Sawtooth";
    IconSymbol[IconSymbol["Saxophone"] = 125] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 126] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 127] = "Search";
    IconSymbol[IconSymbol["SelectDown"] = 128] = "SelectDown";
    IconSymbol[IconSymbol["SelectUp"] = 129] = "SelectUp";
    IconSymbol[IconSymbol["Shadertoy"] = 130] = "Shadertoy";
    IconSymbol[IconSymbol["Shutdown"] = 131] = "Shutdown";
    IconSymbol[IconSymbol["Sine"] = 132] = "Sine";
    IconSymbol[IconSymbol["Solo"] = 133] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 134] = "SoundFont";
    IconSymbol[IconSymbol["Speaker"] = 135] = "Speaker";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 136] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Square"] = 137] = "Square";
    IconSymbol[IconSymbol["Stack"] = 138] = "Stack";
    IconSymbol[IconSymbol["Start"] = 139] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 140] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 141] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 142] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 143] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 144] = "Swap";
    IconSymbol[IconSymbol["System"] = 145] = "System";
    IconSymbol[IconSymbol["Table"] = 146] = "Table";
    IconSymbol[IconSymbol["Tape"] = 147] = "Tape";
    IconSymbol[IconSymbol["TapeReel"] = 148] = "TapeReel";
    IconSymbol[IconSymbol["Time"] = 149] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 150] = "Timeline";
    IconSymbol[IconSymbol["Tone3000"] = 151] = "Tone3000";
    IconSymbol[IconSymbol["Tool"] = 152] = "Tool";
    IconSymbol[IconSymbol["Triangle"] = 153] = "Triangle";
    IconSymbol[IconSymbol["Undo"] = 154] = "Undo";
    IconSymbol[IconSymbol["Unknown"] = 155] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 156] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 157] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 158] = "Vinyl";
    IconSymbol[IconSymbol["Vocoder"] = 159] = "Vocoder";
    IconSymbol[IconSymbol["Volume"] = 160] = "Volume";
    IconSymbol[IconSymbol["VUMeter"] = 161] = "VUMeter";
    IconSymbol[IconSymbol["Waveform"] = 162] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 163] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
